
import Record from "slotworks/model/gameplay/records/record";
import BonusResult from "slotworks/model/gameplay/records/results/bonus-result";
import Result from "slotworks/model/gameplay/records/results/result";
import { ResultBuilder } from "slotworks/server/builders/result-builder";
import { BonusSchema } from "./ic-bonus-record-builder";

class BonusResultBuilder implements ResultBuilder {
    public filter(data: any): boolean {
        const result = data as BonusSchema;

        const isTriggeringRecord = result && result.RESULTS && result.RESULTS.next_game === "BONUS";
        const isRecoveredRecord = result && result.OPEN && result.OPEN.game === "BONUS";

        return isRecoveredRecord || isTriggeringRecord;
    }

    public build(record: Record, data: any): Result[] {
        const bonusResult = new BonusResult("BONUS");

        return [bonusResult];
    }
}

export default new BonusResultBuilder();
